import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0b433178"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bg-light mb-2 mt-3 py-1 px-2 shadow-sm rounded" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "row no-gutters mt-3 mb-4" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-12 d-flex align-items-center justify-content-center" }, [
        /*#__PURE__*/ _createElementVNode("a", {
            href: "/restrito/campanhas/create",
            class: "btn btn-sm btn-primary shadow-none"
        }, [
            /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-plus" }),
            /*#__PURE__*/ _createTextVNode(" Criar Nova Campanha ")
        ])
    ])
], -1));
const _hoisted_3 = { class: "campanhas-container" };
const _hoisted_4 = { class: "item pb-2 mb-5" };
const _hoisted_5 = { class: "row no-gutters" };
const _hoisted_6 = { class: "col-12 mb-3 text-13 text-light d-flex align-items-center justify-content-center" };
const _hoisted_7 = { class: "galeria-container" };
const _hoisted_8 = { class: "col-12 text-center" };
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "col-12" };
const _hoisted_11 = { class: "text-3 text-body" };
const _hoisted_12 = ["href"];
const _hoisted_13 = { class: "text-muted text-1" };
const _hoisted_14 = { title: "Data da criação" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" }, null, -1));
const _hoisted_16 = {
    class: "d-flex flex-wrap justify-content-center",
    style: { "gap": "5px" }
};
const _hoisted_17 = ["href"];
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-edit" }, null, -1));
const _hoisted_19 = ["href"];
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-bullhorn" }, null, -1));
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    class: "btn btn-default btn-sm shadow-none",
    href: "/restrito/doacoes/recebidas"
}, " Doações Recebidas ", -1));
const _hoisted_22 = ["href"];
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-edit" }, null, -1));
const _hoisted_24 = ["href"];
const _hoisted_25 = ["href"];
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-link" }, null, -1));
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
    key: 0,
    class: "d-flex justify-content-center"
};
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "text-1 text-danger text-right font-weight-bold" }, "Campanha Suspensa", -1));
const _hoisted_30 = [
    _hoisted_29
];
const _hoisted_31 = {
    key: 1,
    class: "d-flex justify-content-center"
};
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "text-1 text-danger text-right font-weight-bold" }, "Campanha Encerrada", -1));
const _hoisted_33 = [
    _hoisted_32
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MobileLikeNavHeader = _resolveComponent("MobileLikeNavHeader");
    const _component_GaleriaCarrossel = _resolveComponent("GaleriaCarrossel");
    const _component_ModalConfirmacaoCampanha = _resolveComponent("ModalConfirmacaoCampanha");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_MobileLikeNavHeader, {
                title: "Minhas Campanhas",
                height: "100px",
                "go-back-url": "/restrito#/"
            }),
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campanhas, (campanha) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_GaleriaCarrossel, {
                                        vitrines: campanha.vitrines,
                                        height: "100px"
                                    }, null, 8, ["vitrines"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("h5", _hoisted_11, [
                                            _createElementVNode("a", {
                                                href: '/restrito/campanhas/' + campanha.id + '/edit',
                                                class: "text-black"
                                            }, _toDisplayString(campanha.titulo), 9, _hoisted_12)
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("span", _hoisted_14, [
                                                _hoisted_15,
                                                _createTextVNode(" " + _toDisplayString(_ctx.converteDataHora(campanha.created_at)), 1)
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("a", {
                                        class: "btn btn-default btn-sm shadow-none",
                                        href: '/restrito/campanhas/' + campanha.id + '/edit'
                                    }, [
                                        _hoisted_18,
                                        _createTextVNode(" Editar ")
                                    ], 8, _hoisted_17),
                                    (campanha.causa?.is_politica)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "btn btn-default btn-sm shadow-none",
                                            href: '/restrito/campanhas/' + campanha.id + '/novidades'
                                        }, [
                                            _hoisted_20,
                                            _createTextVNode(" Novidades (" + _toDisplayString(campanha.novidades.length) + ") ", 1)
                                        ], 8, _hoisted_19))
                                        : _createCommentVNode("", true),
                                    _hoisted_21,
                                    (campanha.causa?.is_politica)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            class: "btn btn-default btn-sm shadow-none",
                                            href: '/restrito/campanhas/' + campanha.id + '/edit'
                                        }, [
                                            _hoisted_23,
                                            _createTextVNode(" Número de Candidato ")
                                        ], 8, _hoisted_22))
                                        : _createCommentVNode("", true),
                                    (campanha.is_ativo)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            (!campanha.campanha_encerrada)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("a", {
                                                        class: "btn btn-default btn-sm shadow-none",
                                                        href: '/restrito/campanhas/' + campanha.id + '/encerrar',
                                                        onclick: "return confirm('Tem certeza de que quer encerrar sua campanha?')"
                                                    }, " Encerrar ", 8, _hoisted_24),
                                                    _createElementVNode("a", {
                                                        class: "btn btn-default btn-sm shadow-none",
                                                        target: "_blank",
                                                        href: campanha.url
                                                    }, [
                                                        _hoisted_26,
                                                        _createTextVNode(" Ver Campanha ")
                                                    ], 8, _hoisted_25),
                                                    _createElementVNode("span", {
                                                        class: "btn btn-default btn-sm shadow-none",
                                                        onClick: ($event) => { _ctx.copiarLink(campanha.url_encurtada, $event.target); }
                                                    }, " Copiar link ", 8, _hoisted_27)
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ], 64))
                                        : _createCommentVNode("", true)
                                ]),
                                (!campanha.is_ativo)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
                                    : _createCommentVNode("", true),
                                (campanha.campanha_encerrada)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]));
                }), 256))
            ])
        ]),
        (_ctx.confirmacaoCampanhaId)
            ? (_openBlock(), _createBlock(_component_ModalConfirmacaoCampanha, {
                key: 0,
                "campanha-id": _ctx.confirmacaoCampanhaId
            }, null, 8, ["campanha-id"]))
            : _createCommentVNode("", true)
    ], 64));
}
